<h1 class="mb-5">Companies</h1>

<div class="row">
    <div class="col p-0">
      <div class="form-group">
        <input 
        type="text" 
        class="form-control" 
        placeholder="Search for company..." 
        [formControl]="searchControl">  </div>
    </div>
    <div class="col p-0">
      <a href="/homeAdmin/v2/companies/create" class="btn btn-primary float-right">Add Company</a>
    </div>
  </div>

<div _ngcontent-sph-c113="" class="row">
<table class="table table-striped">
    <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">VAT Number</th>
          <th scope="col">Type</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let company of companies">
          <td scope="row">{{ company.name }}</td>
          <td>{{ company.vatNumber }}</td>
          <td>{{ company.type || 'N/A' }}</td>
          <td class="text-right">
            <a [routerLink]="['/homeAdmin/v2/companies', company.id]" class="btn btn-primary btn-sm btn-spacing">View</a>
            <a [routerLink]="['/homeAdmin/v2/companies', company.id, 'users']" class="btn btn-primary btn-sm">View Users</a>
          </td>
        </tr>
      </tbody>
      
</table>
</div>
